<ng-template (backdropClick)="onCloseClick()" cdkConnectedOverlay>
  <div (click)="onCloseClick()" class="dropdown-content">
    <ng-content></ng-content>
  </div>
</ng-template>
